export const environment = {
  // dangkykhoatu_api: 'http://localhost:3000/api/',
  dangkykhoatu_api: 'https://stagingapi.dangky.clbcucvang.com/api/',
  loginUser: 'auth/login',
  logoutUser: 'auth/logout',
  masterDataGroups: 'master-data/groups',
  masterDataLHLGroupNames: 'master-data/lhl-group-names',
  masterDataLHLClassNamesByGroupName: 'master-data/lhl-class-names',
  masterDataProvinces: 'master-data/provinces',
  masterDataCommuneProvinceName: 'master-data/commune-by-province-name',
  searchPTTT: 'clb-tuoi-tre/search',
  searchPTTTByKhoi: 'clb-tuoi-tre/search-khoi',
  exportAllPTTT: 'clb-tuoi-tre/export-all',
  exportKhoiPTTT: 'clb-tuoi-tre/export-khoi',
  templateImportCLBTT: 'template/import-clb-tt',
  templateImportCLBTTKhoi: 'template/khoi/import-clb-tt',
  validateImportCLBTT: 'clb-tuoi-tre/validate-import-excel',
  inactiveCLBTT: 'clb-tuoi-tre/inactive/',
  importCLBTT: 'clb-tuoi-tre/import-excel',
  importCLBTTKhoi: 'clb-tuoi-tre/khoi/import-excel',
  userChangePassword: 'user/change-password',
  userCLBTTProfileUpdate: 'clb-tuoi-tre/update-profile/',
  userCLBTTProfileCLBUpdate: 'clb-tuoi-tre/clb/update-pttt/',
  userCLBTTProfileCLBAdd: 'clb-tuoi-tre/clb/add-pttt',
  userCLBTTProfileKhoiUpdate: 'clb-tuoi-tre/khoi/update-pttt/',
  userCLBTTProfileKhoiAdd: 'clb-tuoi-tre/khoi/add-pttt',
  refreshUser: 'user/refresh-profile',
  forgetPassword: 'auth/forget-password',
  getUserProfile: 'user/user-profile',
  sumPTTTForCLBByGioiTinh: 'clb-tuoi-tre/sum/clb/gioi-tinh',
  sumByKhoiSinhHoatAndChucDanh: 'clb-tuoi-tre/sum/clb/chuc-danh-tai-khoi',
  sumPTTTForKhoiByGioiTinh: 'clb-tuoi-tre/sum/khoi/gioi-tinh',
  sumPTTTForKhoiByChucDanh: 'clb-tuoi-tre/sum/khoi/chuc-danh-tai-khoi',
  //start add by 22-Mar-2026
  formRequestBLDBPHTPT: 'https://forms.gle/eDyuAg9Nguyapqc6A',
  formRequestBCSKhoiBPHTPT: 'https://forms.gle/KLwEWtawrfSRmM7u7',
  chatGroupSupportBLDBPHTPT: 'https://chat.whatsapp.com/ImcMYw3KaXtG9fcTaQ78ZG',
  chatGroupSupportBCSKhoiBPHTPT:
    'https://chat.whatsapp.com/KL9n6oRWSjbBsGP6hwS0Hy',
  listBLDCLBTT:
    'https://docs.google.com/spreadsheets/d/1H2sujUhISJpkD1nVY1hkzLgQsZ98ILc7Xy81URKrVeE/edit',
  //start add by 29-Mar-2026
  searchLDKhoiTT: 'tt-phu-trach-khoi/search',
  addLDKhoiTT: 'tt-phu-trach-khoi/add',
  updateLDKhoiTT: 'tt-phu-trach-khoi/update/',
  inactiveLDKhoiTT: 'tt-phu-trach-khoi/inactive/',
  getUsersCVWithoutLDKhoiTT: 'clb-cuc-vang/users-without-ld-khoi-tt',
  getUsersTTWithoutLDKhoiTT: 'clb-tuoi-tre/users-without-ld-khoi-tt',
  //start add by 12-Apr-2026
  getPhuTrachKhoi: 'tt-phu-trach-khoi/phu-trach-khoi',
  getPhuTrachKhoiByUsername: 'tt-phu-trach-khoi/phu-trach-khoi-username',
};
